module.exports = __webpack_public_path__ + "static/media/r18.33272ef7.png";